import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propShape } from '../../../../../../helpers/custom-prop-types';
import Image from '../../../../../Ui/Common/Image';
const MemberRowPersonalityColumn = (props) => {
    const { personality } = props;
    const { colorCode, file, name } = personality;
    const style = useMemo(() => ({ color: colorCode || '#000000' }), [colorCode]);
    return (_jsxs("li", Object.assign({ className: 'personality_column' }, { children: [_jsx("div", Object.assign({ className: 'thumbnail_box' }, { children: _jsx(Image, { alt: '', isObjectFit: true, src: file, useImage: true }) })), _jsx("div", Object.assign({ className: 'name_row', style: style }, { children: name }))] })));
};
MemberRowPersonalityColumn.propTypes = {
    personality: propShape().isRequired,
};
export default MemberRowPersonalityColumn;
